module.exports = __webpack_public_path__ + "static/media/ico-floating-vendors.04951835.svg";